<template>
  <div class="Iwanttocompete">
    <div v-if="iscolse==false">
      <div v-if="this.userInfo.customerType == 1">
          <div class="headtitles">
          <p>{{ $t("Productssubmitted") }}</p>
          {{ $t("Productssubmittedbody") }}
        </div>
        <div class="from-data">
          <el-form :rules="rules" label-position="left" label-width="80px" :model="formLabelAlign">
            <el-form-item :label="$t('ContestScope')">
              <el-select v-model="formLabelAlign.competitionRangeId"  style="width: 100%;max-width: 480px;" popper-class="el-selected" :placeholder="$t('pleaseChoose')">
                <el-option
                  v-for="(item, i) in scopeList"
                  :key="i"
                  :label="item.rangeName"
                  :value="item.id">
                </el-option>
              </el-select>

            </el-form-item>

            <el-form-item :label="$t('ProductName')">
              <el-input
                v-model="formLabelAlign.workName"
                :placeholder="$t('ProductNameplaceholder')"
              ></el-input>
            </el-form-item>


            <el-form-item :label="$t('DesignCompletionDate')">
              <!-- <el-input
                v-model="formLabelAlign.completionDate"
                :placeholder="$t('pleaseDesignCompletionDate')"
              ></el-input> -->
              <el-date-picker
                v-model="formLabelAlign.completionDate"
                value-format="yyyy-MM-dd"
                format="yyyy - MM - dd "
                :clearable="false"
                :picker-options="pickerOptions"
                type="date"
                :placeholder="$t('pleaseDesignCompletionDate')">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('CopyrightRegistration')">
              <!-- <el-input
                v-model="formLabelAlign.copyrightRegistration"
                :placeholder="$t('pleaseCopyrightRegistration')"
              ></el-input> -->
              <el-radio v-model="formLabelAlign.copyrightRegistration" label="1">{{$t("yes")}}</el-radio>
              <el-radio v-model="formLabelAlign.copyrightRegistration" label="0">{{$t("no")}}</el-radio>
            </el-form-item>
            <el-form-item :label="$t('TimeToMarket')" class="select-date">
              <!-- <el-input
                v-model="formLabelAlign.marketDate"
                :placeholder="$t('pleaseTimeToMarket')"
              ></el-input> -->
              <el-date-picker
                v-model="formLabelAlign.marketDate"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                format="yyyy - MM - dd "
                :clearable="false"
                type="date"
                :placeholder="$t('pleaseTimeToMarket')">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('PatentApplication')">
              <!-- <el-input
                v-model="formLabelAlign.patent"
                :placeholder="$t('pleasePatentApplication')"
              ></el-input> -->
              <el-radio v-model="formLabelAlign.patent" label="1">{{$t("yes")}}</el-radio>
              <el-radio v-model="formLabelAlign.patent" label="0">{{$t("no")}}</el-radio>
            </el-form-item>

            <el-form-item :label="$t('personnelInformation')">
              <el-input-number style="visibility: hidden;" size="small" v-model="num"></el-input-number>

                <div class="flex" style="align-items: center; margin-bottom: 10px; max-width: 480px;" v-for="(item,index) in formLabelAlign.personnelInformation" :key="index">
                    <span style="flex:1">{{$t("name")}}</span> <el-input
                    v-model="item.name"
                    style="flex:3"
                    :placeholder="$t('pleaseName')"
                    ></el-input>
                    <span style="flex:1;margin-left: 10px;">{{$t("Tel")}}:</span> 
                    <el-input
                        style="flex:4;"
                        v-model="item.contactPhone"
                        :maxlength="11"
                        :placeholder="$t('pleaseTel')"
                    ></el-input>
                    <el-button @click="addPerson" size="mini" v-if="index == 0" style="margin-left: 10px; padding: 0; height: 30px;width: 50px;">{{$t("add")}}</el-button>
                    <el-button @click="remotePerson(index)" size="mini" v-else style="padding: 0;margin-left: 10px; height: 30px;width: 50px;">{{$t("delete")}}</el-button>
                </div> 
            <!-- <div>
              <span>{{$t("name")}}</span> <el-input
                v-model="formLabelAlign.personnelName2"
                :placeholder="$t('pleaseName')"
              ></el-input>
              <span>{{$t("Tel")}}:</span> <el-input
                v-model="formLabelAlign.personnelTel2"
                :placeholder="$t('pleaseTel')"
              ></el-input>
            </div> -->
            </el-form-item>

            <el-form-item :label="$t('designIntroduction')" style="position: relative;">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 12}"
                  :maxlength="800"
                  :placeholder="$t('pleaseDesignIntroduction')"
                  v-model="formLabelAlign.designDescription">
              </el-input>
              <span class="max-length">{{$t("maxLength")}}:{{formLabelAlign.designDescription.length}}/800</span>
            </el-form-item>

            <el-form-item :label="$t('Company')">
              <el-input
                v-model="formLabelAlign.companyName"
                :placeholder="$t('Companyplaceholder')"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('postalAddress')">
              <el-input
                v-model="formLabelAlign.postalAddress"
                :placeholder="$t('pleasePostalAddress')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('ContactName')">
              <el-input
                v-model="formLabelAlign.contactName"
                :placeholder="$t('pleaseContactName')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="mobilePhone" :label="$t('MobilePhone')">
              <el-input
                v-model="formLabelAlign.mobilePhone"
                :placeholder="$t('pleaseMobilePhone')"
              ></el-input>
            </el-form-item>



            <el-form-item :label="$t('job')">
              <el-input
                v-model="formLabelAlign.post"
                :placeholder="$t('pleaseJob')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('fixedTelephone')">
              <el-input
                v-model="formLabelAlign.fixedTelephone"
                :placeholder="$t('pleaseFixedTelephone')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="eMail" :label="$t('email')">
              <el-input
                v-model="formLabelAlign.eMail"
                :placeholder="$t('pleaseEmail')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('companyIntroduction')" style="position: relative;">
              <el-input
                  type="textarea"
                  :maxlength="800"
                  :autosize="{ minRows: 6, maxRows: 12}"
                  :placeholder="$t('pleaseCompanyIntroduction')"
                  v-model="formLabelAlign.briefIntroduction">

              </el-input>
              <span class="max-length">{{$t("maxLength")}}:{{formLabelAlign.briefIntroduction.length}}/800</span>
            </el-form-item>


            <!-- <el-form-item :label="$t('ProductBrand')">
              <el-input
                v-model="formLabelAlign.productBrand"
                :placeholder="$t('ProductBrandplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Producttype')">
              <el-input
                v-model="formLabelAlign.productType"
                :placeholder="$t('Producttypeplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Productsize')">
              <el-input
                v-model="formLabelAlign.productSize"
                :placeholder="$t('Productsizeplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('NetWeight')">
              <el-input
                v-model="formLabelAlign.netWeight"
                :placeholder="$t('NetWeightplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Price')">
              <el-input
                v-model="formLabelAlign.productPrice"
                :placeholder="$t('Priceplaceholder')"
              ></el-input>
            </el-form-item> -->
            <el-form-item class="uploads" :label="$t('Mainpicturesofproducts')">
              <el-upload
                ref="entriesPictures"
                list-type="picture-card"
                :accept="acceptimg"
                :action="postUrl"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess1"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{ $t("Mainpicturesofproductsplaceholder") }}</span>
            </el-form-item>

            <el-form-item class="uploads" :label="$t('Videos')">
              <el-upload
                list-type="picture-card"
                :action="postUrl"
                :accept="acceptvideo"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed2"
                :limit="videoListLimit"
                :before-upload="beforeVideoUpload"
                :on-success="handleSuccess4"
                :on-progress="uploadProgress"
                :show-file-list="false"
                :on-remove="handleRemove4"
              >
                <i
                  v-if="!formLabelAlign.productVideos"
                  class="el-icon-plus"
                ></i>
                <div v-if="formLabelAlign.productVideos" class="video-wrapwrap">
                  <video
                    style="width: 100%; height: 100%"
                    controls="controls"
                    autoplay="true"
                    ref="videoPlay"
                    :src="videoSrc"
                  >
                    您的浏览器不支持视频播放
                  </video>
                  <span
                    v-if="this.formLabelAlign.productVideos"
                    class="el-upload-list__item-delete video-wrapwrap-delete"
                    @click.stop="handleRemove4"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </el-upload>
              <el-progress :percentage="percentage"  :stroke-width="6"></el-progress>
              
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts" v-if="!formLabelAlign.productVideos">{{ $t("Videosplaceholder") }}</span>
              <span class="ts" style="color:#6f73f4;cursor: pointer;" v-if="formLabelAlign.productVideos" @click.stop="handleRemove4">{{ $t("reVideosplaceholder") }}</span>
            </el-form-item>
            <el-form-item class="uploads" :label="$t('files')">
              <el-upload
              class="upload-demo"
              :action="postUrl"
              :on-success="handleSuccess10"
              :on-remove="handleRemove10"
              :file-list="formLabelAlign.presentation">
              <el-button size="small" class="upload-file" type="primary">{{$t("clickUp")}}</el-button>
            </el-upload>
            </el-form-item> 
            

            <!-- <el-form-item
              class="uploads"
              :label="$t('Productapplicationscenariopictures')"
            >
              <el-upload
                list-type="picture-card"
                :action="postUrl"
                :accept="acceptimg"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess2"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove2"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{
                $t("Productapplicationscenariopicturesplaceholder")
              }}</span>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads"
              :label="$t('Schematicdiagramofkeypointsofproductdesign')"
            >
              <el-upload
                list-type="picture-card"
                :accept="acceptimg"
                :action="postUrl"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess3"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove3"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{
                $t("Schematicdiagramofkeypointsofproductdesignplaceholder")
              }}</span>
            </el-form-item> -->



            <!-- <el-form-item class="uploads" :label="$t('Producttestingreport')">
              <el-upload
                list-type="picture-card"
                :accept="acceptimg"
                :action="postUrl"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess5"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove5"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{ $t("Producttestingreportplaceholder") }}</span>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Productdescription')">
              <el-input
                v-model="formLabelAlign.productDescription"
                :placeholder="$t('Productdescriptionplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Designhouse')">
              <el-input
                v-model="formLabelAlign.designCompany"
                :placeholder="$t('Designhouseplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Manufacturingcompany')">
              <el-input
                v-model="formLabelAlign.manufacturingCompany"
                :placeholder="$t('Manufacturingcompanyplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('PatentNumber')">
              <el-input
                v-model="formLabelAlign.patentNo"
                :placeholder="$t('PatentNumberplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads"
              :label="$t('Certificateforinventorspatentright')"
            >
              <el-upload
                list-type="picture-card"
                :accept="acceptimg"
                :action="postUrl"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess6"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove6"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{
                $t("Certificateforinventorspatentrightplaceholder")
              }}</span>
            </el-form-item> -->

            <!-- <el-form-item class="uploads" :label="$t('UtilityModelPatent')">
              <el-upload
                list-type="picture-card"
                :accept="acceptimg"
                :action="postUrl"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess7"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove7"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{ $t("UtilityModelPatentplaceholder") }}</span>
            </el-form-item> -->

            <!-- <el-form-item class="uploads" :label="$t('DesignPatent')">
              <el-upload
                list-type="picture-card"
                :accept="acceptimg"
                :action="postUrl"
                :auto-upload="true"
                :multiple="true"
                :on-exceed="handleExceed"
                :limit="imgListLimit"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess8"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove8"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="ts">{{ $t("DesignPatentplaceholder") }}</span>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads-inputs"
              :label="$t('DescriptionofSpecialFunctions')"
            >
              <el-input
                v-model="formLabelAlign.specialFunctionDescription"
                :placeholder="$t('DescriptionofSpecialFunctionsplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item class="uploads-inputs" :label="$t('SpecialDesign')">
              <el-input
                v-model="formLabelAlign.specialDesignDescription"
                :placeholder="$t('SpecialDesignplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('SpecialMaterials')">
              <el-input
                v-model="formLabelAlign.specialMaterials"
                :placeholder="$t('SpecialMaterialsplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Specialprocess')">
              <el-input
                v-model="formLabelAlign.specialProcess"
                :placeholder="$t('Specialprocessplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads-inputs"
              :label="$t('OtherInnovationDescriptions')"
            >
              <el-input
                v-model="formLabelAlign.otherInnovations"
                :placeholder="$t('OtherInnovationDescriptionsplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item class="uploads-inputs" :label="$t('Aerodynamics')">
              <el-input
                v-model="formLabelAlign.aerodynamics"
                :placeholder="$t('Aerodynamicsplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item class="uploads-inputs" :label="$t('Ergonomics')">
              <el-input
                v-model="formLabelAlign.ergonomics"
                :placeholder="$t('Ergonomicsplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads-inputs"
              :label="$t('Lightweightdescription')"
            >
              <el-input
                v-model="formLabelAlign.lightweightDescription"
                :placeholder="$t('Lightweightdescriptionplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item class="uploads-inputs" :label="$t('Comfort')">
              <el-input
                v-model="formLabelAlign.comfortDescription"
                :placeholder="$t('Comfortplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Weightcarryingability')">
              <el-input
                v-model="formLabelAlign.loadCapacity"
                :placeholder="$t('Weightcarryingabilityptionplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Convenience')">
              <el-input
                v-model="formLabelAlign.convenience"
                :placeholder="$t('Convenienceplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('Security')">
              <el-input
                v-model="formLabelAlign.security"
                :placeholder="$t('Securityplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item :label="$t('EnvironmentalPerformance')">
              <el-input
                v-model="formLabelAlign.environmentalProtection"
                :placeholder="$t('EnvironmentalPerformanceplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads-inputs-one"
              :label="$t('Adaptabilitytospecialroadconditions')"
            >
              <el-input
                v-model="formLabelAlign.roadConditions"
                :placeholder="$t('Adaptabilitytospecialroadconditionsplaceholder')"
              ></el-input>
            </el-form-item> -->

            <!-- <el-form-item
              class="uploads-inputs"
              :label="$t('DescriptionofOtherFeatures')"
            >
              <el-input
                v-model="formLabelAlign.otherFeatures"
                :placeholder="$t('DescriptionofOtherFeaturesplaceholder')"
              ></el-input>
            </el-form-item> -->
            <div class="submission" @click.stop="submit">
              {{ $t("informationsubmission") }}
            </div>
          </el-form>
        </div>
      </div>
      <div v-else class="judge-tips">
        {{ $t("judgeCant") }}
      </div>
    </div>
    <div v-if="iscolse==true" style="font-size:20px;margin-bottom:20px">
      {{$t("tis")}}
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"请输入手机号":'Please enter your mobile number'));
      } else if (!/^1[23456789]\d{9}$/.test(value)) {
        callback(new Error(this.lang=='zh'?"请输入正确的手机号":'Please enter the correct mobile phone number'));
      } else {
        callback();
      }
    };
    var checkPhone1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"请输入手机号":'Please enter your mobile number'));
      } else if (!/^1[23456789]\d{9}$/.test(value)) {
        callback(new Error(this.lang=='zh'?"请输入正确的手机号":'Please enter the correct mobile phone number'));
      } else {
        callback();
      }
    };
    var checkMailbox = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"请输入邮箱地址":'Please enter email address'));
      } else if (!/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)) {
        callback(new Error(this.lang=='zh'?"请输入正确的邮箱地址":'Please enter the correct email address'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
             disabledDate(time) {
                return time.getTime() > Date.now();
              }
             },
      rules:{
        // regionPhone: [{ validator: checkOther }],
        mobilePhone: [{ validator: checkPhone}], // 'blur'是鼠标失去焦点的时候会触发验证
        eMail: [{validator: checkMailbox}],
        contactPhone: [{ validator: checkPhone1}],
      },
      formLabelAlign: {
        companyName: "",
        workName: "",
        entriesPictures: "",
        // productPicturesUse: "",
        // productDesign: "",
        productVideos: "",
        completionDate:"",
        copyrightRegistration:"1",
        marketDate:"",
        patent:"1",
        postalAddress:"",
        contactName:"",
        mobilePhone:"",
        post:"",
        fixedTelephone:"",
        eMail:"",
        designDescription:"",
        briefIntroduction:"",
        competitionRangeId:"",
        presentation:[],
        personnelInformation:[{
          name:"",
          contactPhone:""
        }]
      },
      iscolse:false,
      percentage:0,
      num:1,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,

      imgListLimit: 6,
      videoListLimit: 10,
      postUrl: this.$upload,
      videoSrc: "",
      submitLoading: false,

      acceptimg: ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PNG,.GIF,.BMP",
      acceptvideo: ".mp4,ogg,flv,avi,wmv,rmvb",
      scopeSelect:"请选择",
      scopeList:[],
      fileArr:[],
      personnelInformation:[{
          name:"",
          contactPhone:""
        }]
      
      // mp4、ogg、flv、avi、wmv、rmvb
    };
  },
  created(){
     let Currenttime =new Date();
      let date = new Date('2022-11-30');
      let time1 = date.getTime();//固定时间
      let Y = Currenttime .getFullYear()
      let M = Currenttime.getMonth() + 1;
      let D = Currenttime.getDate();
      let datadd = new Date(`${Y}-${M}-${D}`);
      let time2 = datadd.getTime();//当前时间
      // if(time2>time1){
      //   this.iscolse = true
      // }
    // 沒登陸
    if (!this.checkLogin()) {
        this.SETLOGINTYPE(1);
        this.SETACTIVES(null);
        this.SETACTIVE(7);
        return
      };
    this.$getHttp("pc/CompetitionRange/findAllCompetitionRange").then(res=>{
      this.scopeList = res.data;
    })
  },
  methods: {
    addPerson(){
      this.formLabelAlign.personnelInformation.push({name:"",
          contactPhone:""})
    },
    remotePerson(index){
      this.formLabelAlign.personnelInformation.splice(index,1)
    },
    handleArr(target, url, type) {
      if (!Array.isArray(target)) {
        target = [];
      }
      if (type == "add") {
        target.push(url);
      } else {
        target.splice(
          target.findIndex((item) => item == url),
          1
        );
        console.log(target)
      }
      return target;
    },
    handleSuccess1(file, fileList) {
      console.log(file);
      this.formLabelAlign.entriesPictures = this.handleArr(
        this.formLabelAlign.entriesPictures,
        file.attach.attachPath,
        "add"
      );
    },
    handleRemove1(file, fileList) {
      this.formLabelAlign.entriesPictures = this.handleArr(
        this.formLabelAlign.entriesPictures,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleSuccess2(file, fileList) {
      this.formLabelAlign.productPicturesUse = this.handleArr(
        this.formLabelAlign.productPicturesUse,
        file.attach.attachPath,
        "add"
      );
    },
    handleRemove2(file, fileList) {
      this.formLabelAlign.productPicturesUse = this.handleArr(
        this.formLabelAlign.productPicturesUse,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleSuccess3(file, fileList) {
      this.formLabelAlign.productDesign = this.handleArr(
        this.formLabelAlign.productDesign,
        file.attach.attachPath,
        "add"
      );
    },
    handleRemove3(file, fileList) {
      console.log(file)
      console.log(fileList)
      this.formLabelAlign.productDesign = this.handleArr(
        this.formLabelAlign.productDesign,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleSuccess4(file, fileList) {
      console.log(file)
      console.log(fileList)
      this.formLabelAlign.productVideos = file.attach.attachPath;
      this.videoSrc = this.$imgUrl + this.formLabelAlign.productVideos;
      // this.videoSrc='https://img.cdn.aliyun.dcloud.net.cn/guide/uniapp/%E7%AC%AC1%E8%AE%B2%EF%BC%88uni-app%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D%EF%BC%89-%20DCloud%E5%AE%98%E6%96%B9%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B@20200317.mp4'
    },
    handleRemove4(file, fileList) {
      console.log(file)
      console.log(fileList)
      this.formLabelAlign.productVideos= "";
      this.videoSrc = "";
      this.percentage = 0
    },
    handleRemovehandleRemove() {},
    handleSuccess5(file, fileList) {
      this.formLabelAlign.productReport = this.handleArr(
        this.formLabelAlign.productReport,
        file.attach.attachPath,
        "add"
      );
    },
    handleRemove5(file, fileList) {
      this.formLabelAlign.productReport = this.handleArr(
        this.formLabelAlign.productReport,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleSuccess6(file, fileList) {
      this.formLabelAlign.patentInvention = this.handleArr(
        this.formLabelAlign.patentInvention,
        file.attach.attachPath,
        "add"
      );
    },
    handleRemove6(file, fileList) {
      this.formLabelAlign.patentInvention = this.handleArr(
        this.formLabelAlign.patentInvention,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleSuccess7(file, fileList) {
      this.formLabelAlign.utilityModel = this.handleArr(
        this.formLabelAlign.utilityModel,
        file.attach.attachPath,
        "add"
      );
    },
    handleRemove7(file, fileList) {
      this.formLabelAlign.utilityModel = this.handleArr(
        this.formLabelAlign.utilityModel,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleSuccess8(file, fileList) {
      this.formLabelAlign.industrialDesign = this.handleArr(
        this.formLabelAlign.industrialDesign,
        file.attach.attachPath,
        "add"
      );
    },
    
    handleRemove8(file, fileList) {
      this.formLabelAlign.industrialDesign = this.handleArr(
        this.formLabelAlign.industrialDesign,
        file.response.attach.attachPath,
        "sub"
      );
    },
    handleRemove10(file, fileList) {
      this.formLabelAlign.presentation = this.handleArr(
        this.formLabelAlign.presentation,
        file.response.attach.attachPath,
        "sub"
      );
      console.log(this.formLabelAlign.presentation)
    },
    handleSuccess10(file, fileList) {
      
      this.formLabelAlign.presentation = this.handleArr(
        this.formLabelAlign.presentation,
        file.attach.attachPath,
        "add"
      );
    },

    // beforeUploadFile(file){
    //   console.log(file)
    //   console.log(this.formLabelAlign.presentation)
    //   console.log(1)
    //   let n = file.name.indexOf(".");
    //   let str = file.name.slice(n,file.name.length);
    //   console.log(n, str)
    //   let bool=this.fileArr.includes(str)
    //   if (!bool) {
    //     this.fileArr.push(str)
    //   }else{
    //     this.$message.error("类型一样的文件不能多次上传！");
    //     return
    //   }
    
    //   return !bool;

    // },

    //
    // 上传图片限制
    beforeAvatarUpload(file) {
      const isJPG =
        file.type.substring(0, 5) === "image" ||
        file.type.substring(6, 7) == "g";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是图片格式!");
        return;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return;
      }
      return isJPG && isLt2M;
    },
    // 上传视频限制
    beforeVideoUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      // if (
      //   [
      //     "video/mp4",
      //     "video/ogg",
      //     "video/flv",
      //     "video/avi",
      //     "video/wmv",
      //     "video/rmvb",
      //   ].indexOf(file.type) == -1
      // ) {
      //   this.$message.error(
      //     "上传视频只能是 mp4、ogg、flv、avi、wmv、rmvb 格式!"
      //   );
      //   return false;
      // }
      // if (!isLt50M) {
      //   this.$message.error("上传视频大小不能超过 50MB!");
      //   return false;
      // }
      // return true;
    },
    // 最小文件视频数量
    handleExceed2(fileList, files) {
      this.$message.warning(
        `当前限制选择 ${this.videoListLimit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${fileList.length} 个文件`
      );
    },
    // 最小文件图片数量
    handleExceed(fileList, files) {
      this.$message.warning(
        `限制选择 ${this.imgListLimit} 个文件`
      );
      // this.$message.warning(
      //   `当前限制选择 ${this.imgListLimit} 个文件，本次选择了 ${
      //     files.length
      //   } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      // );
    },
    // 公用预览
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 公用下载
    handleDownload(file) {
      // window.open(file.url, "_self");
      console.log(file);
      // return
      fetch(file.url).then((res) => {
        console.log(res);
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = file.name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    },

    uploadProgress(event,file,fileList){
        let _self = this;
        if(event.lengthComputable){
          let val = (event.loaded / event.total * 100 ).toFixed(0);
          var progress = parseInt(val);
            _self.percentage = progress;
        }
      },

    //提交
    submit() {
      if (!this.checkLogin()) {
        this.SETLOGINTYPE(1);
        this.SETACTIVES(null);
        this.SETACTIVE(7);
        return
      };
      console.log(this.formLabelAlign.competitionRangeId)
      console.log(this.formLabelAlign)

      

      if (this.formLabelAlign.personnelInformation[0].name == "" || this.formLabelAlign.personnelInformation[0].contactPhone == "") {
        this.$message({
          message: this.$t("pleasePersonnelInformation"),
        });
        return;
      }
      

      if (this.formLabelAlign.competitionRangeId == "") {
        this.$message({
          message: this.$t("pleaseContestScope"),
        });
        return;
      }
      if (this.formLabelAlign.companyName == "") {
        this.$message({
          message: this.$t("Companyplaceholder"),
        });
        return;
      }
      if (this.formLabelAlign.workName == "") {
        this.$message({
          message: this.$t("ProductNameplaceholder"),
        });
        return;
      }
      // -----------------------------------------
      
      // if (this.formLabelAlign.designCompletionDate == "") {
      //   this.$message({
      //     message: this.$t("pleaseDesignCompletionDate"),
      //   });
      //   return;
      // }
      if (this.formLabelAlign.copyrightRegistration == "") {
        this.$message({
          message: this.$t("pleaseCopyrightRegistration"),
        });
        return;
      }
      if (this.formLabelAlign.marketDate == "") {
        this.$message({
          message: this.$t("pleaseTimeToMarket"),
        });
        return;
      }
      if (this.formLabelAlign.patent == "") {
        this.$message({
          message: this.$t("pleasePatentApplication"),
        });
        return;
      }
      if (this.formLabelAlign.postalAddress == "") {
        this.$message({
          message: this.$t("pleasePostalAddress"),
        });
        return;
      }
      if (this.formLabelAlign.contactName == "") {
        this.$message({
          message: this.$t("pleaseContactName"),
        });
        return;
      }
      if (this.formLabelAlign.mobilePhone == "") {
        this.$message({
          message: this.$t("pleaseMobilePhone"),
        });
        return;
      }
      if (this.formLabelAlign.fixedTelephone == "") {
        this.$message({
          message: this.$t("pleaseFixedTelephone"),
        });
        return;
      }
      if (this.formLabelAlign.eMail == "") {
        this.$message({
          message: this.$t("pleaseEmail"),
        });
        return;
      }
      if (this.formLabelAlign.post == "") {
        this.$message({
          message: this.$t("pleaseJob"),
        });
        return;
      }
      if (this.formLabelAlign.designDescription == "") {
        this.$message({
          message: this.$t("pleaseDesignIntroduction"),
        });
        return;
      }
      if (this.formLabelAlign.completionDate == "") {
        this.$message({
          message: this.$t("pleaseDesignCompletionDate"),
        });
        return;
      }
      if (this.formLabelAlign.briefIntroduction == "") {
        this.$message({
          message: this.$t("pleaseCompanyIntroduction"),
        });
        return;
      }
      







      if (this.formLabelAlign.entriesPictures.length == 0) {
        this.$message({
          message: this.$t("Mainpicturesofproductsplaceholder"),
        });
        return;
      }
      if (this.formLabelAlign.entriesPictures.length < 3 || this.formLabelAlign.entriesPictures.length >6) {
        this.$message({
          message: this.$t("pictureLength"),
        });
        return;
      }
      // if (this.formLabelAlign.productBrand == "") {
      //   this.$message({
      //     message: this.$t("ProductBrandplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.productType == "") {
      //   this.$message({
      //     message: this.$t("Producttypeplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.productSize == "") {
      //   this.$message({
      //     message: this.$t("Productsizeplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.netWeight == "") {
      //   this.$message({
      //     message: this.$t("NetWeightplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.productPrice == "") {
      //   this.$message({
      //     message: this.$t("Priceplaceholder"),
      //   });
      //   return;
      // }
      
      // if (this.formLabelAlign.productPicturesUse.length == 0) {
      //   this.$message({
      //     message: this.$t("Productapplicationscenariopicturesplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.productDesign.length == 0) {
      //   this.$message({
      //     message: this.$t(
      //       "Schematicdiagramofkeypointsofproductdesignplaceholder"
      //     ),
      //   });
      //   return;
      // }
      console.log(this.formLabelAlign.productVideos)
      if (this.formLabelAlign.productVideos.length == 0) {
        this.$message({
          message: this.$t("Videosplaceholder"),
        });
        return;
      }
      if (this.formLabelAlign.presentation.length == 0) {
        this.$message({
          message: this.$t("filesWarn"),
        });
        return;
      }
      // if (this.formLabelAlign.productReport.length == 0) {
      //   this.$message({
      //     message: this.$t("Producttestingreportplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.productDescription == "") {
      //   this.$message({
      //     message: this.$t("Productdescriptionplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.designCompany == "") {
      //   this.$message({
      //     message: this.$t("Designhouseplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.manufacturingCompany == "") {
      //   this.$message({
      //     message: this.$t("Manufacturingcompanyplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.patentNo == "") {
      //   this.$message({
      //     message: this.$t("PatentNumberplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.patentInvention == "") {
      //   this.$message({
      //     message: this.$t("Certificateforinventorspatentrightplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.utilityModel == "") {
      //   this.$message({
      //     message: this.$t("UtilityModelPatentplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.industrialDesign == "") {
      //   this.$message({
      //     message: this.$t("DesignPatentplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.specialFunctionDescription == "") {
      //   this.$message({
      //     message: this.$t("DescriptionofSpecialFunctionsplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.specialDesignDescription == "") {
      //   this.$message({
      //     message: this.$t("SpecialDesignplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.specialMaterials == "") {
      //   this.$message({
      //     message: this.$t("SpecialMaterialsplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.specialProcess == "") {
      //   this.$message({
      //     message: this.$t("Specialprocessplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.otherInnovations == "") {
      //   this.$message({
      //     message: this.$t("OtherInnovationDescriptionsplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.aerodynamics == "") {
      //   this.$message({
      //     message: this.$t("Aerodynamicsplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.ergonomics == "") {
      //   this.$message({
      //     message: this.$t("Ergonomicsplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.lightweightDescription == "") {
      //   this.$message({
      //     message: this.$t("Lightweightdescriptionplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.comfortDescription == "") {
      //   this.$message({
      //     message: this.$t("Comfortplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.loadCapacity == "") {
      //   this.$message({
      //     message: this.$t("Weightcarryingabilityptionplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.convenience == "") {
      //   this.$message({
      //     message: this.$t("Convenienceplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.security == "") {
      //   this.$message({
      //     message: this.$t("Securityplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.environmentalProtection == "") {
      //   this.$message({
      //     message: this.$t("EnvironmentalPerformanceplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.roadConditions == "") {
      //   this.$message({
      //     message: this.$t("Adaptabilitytospecialroadconditionsplaceholder"),
      //   });
      //   return;
      // }
      // if (this.formLabelAlign.otherFeatures == "") {
      //   this.$message({
      //     message: this.$t("DescriptionofOtherFeaturesplaceholder"),
      //   });
      //   return;
      // }
      // if(this.percentage !== 100){
      //   this.$message({
      //     message: this.$t("videoNoFinish"),
      //   });
      //   return;
      // }
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;

      this.formLabelAlign.personnelInformation = JSON.stringify(this.formLabelAlign.personnelInformation) 


      for (const key in this.formLabelAlign) {
        if (Array.isArray(this.formLabelAlign[key])) {
          this.formLabelAlign[key] = this.formLabelAlign[key].join("|");
        }
      }
      this.$postHttp("pc/Entries/insertEntrie", {
        ...this.formLabelAlign,
        userId: this.userInfo.id,
      }).then((res) => {
        if (res.success) {
          // if (res.msg == '您已拥有参赛作品！|You already have an entry!') {
          //   this.$message({
          //     message: this.$t("hadPost"),
          //     type: "error",
          //   });
          //   this.submitLoading = false;
          //   return
          // }
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.submitLoading = false;
          if (this.$route.path.includes("user")) {
            this.reload();
          }
          this.$router.push("/user");
          
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          this.submitLoading = false;
          this.reload();
        }
      });
    },
  },
};
</script>

<style lang="less">
.el-form-item__label {
  font-size: 22px !important;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  // width: 106px !important;
  display: flex;
  flex-direction: column;
}

.el-selected{
  width: 100px;
}

.Iwanttocompete{
  .el-input__suffix{
    right: 6px !important;
  }
}

.submission {
  cursor: pointer;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 220px;
  height: 56px;
  margin-top: 80px;
  background: linear-gradient(262deg, #6a9cff 0%, #5257ff 100%);
  border-radius: 10px 10px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.max-length{
  position: absolute;
  right: 85px;
  bottom: 6px;
  color: #aeb0b4;
  font-size: 12px;
  height: 30px;
}
.uploads-inputs-one {
  .el-form-item__label {
    width: 172px !important;
  }
}

.uploads-inputs {
  .el-form-item__label {
    width: 160px !important;
  }
}

.ts {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.Iwanttocompete {
  .el-input__prefix{
    top: 20px;
  }
}

.uploads {
  display: flex;
  flex-direction: column;
  .el-form-item__label {
    // width: 216px !important;
  }
  .el-upload__input {
    display: none;
  }
  .el-form-item__content {
    margin-left: 107px !important;
    position: relative;
  }
}

.Iwanttocompete{
  .per {
    .el-form-item__content {
      margin-left: 0 !important;
      position: relative;
    }
}
}


.el-input {
  display: block !important;
}

.el-textarea__inner{
  max-width: 480px !important;
}

.Iwanttocompete .el-input .el-input__inner {
  max-width: 480px !important;
  height: 46px ;
  border-radius: 6px 6px 6px 6px !important;
}

.Iwanttocompete {
  text-align: left;
  .headtitles {
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 50px;
    margin-left: 81px;
    p {
      height: 37px;
      font-size: 26px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #6f73f4;
      line-height: 50px;
    }
  }
  .from-data {
    position: relative;
    max-width: 655px;
    margin-left: 283px;
    margin-top: 66px;
    margin-bottom: 187px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-form-item__label {
  font-size: 22px !important;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  width: 100% !important;
}

.uploads-inputs {
  .el-form-item__label {
    width: 160px !important;
  }
}

.ts {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.uploads-inputs-one {
  .el-form-item__label {
    width: 100% !important;
  }
}

.uploads-inputs {
  .el-form-item__label {
    width: 100% !important;
  }
}
.Iwanttocompete {
  .el-form-item__content {
    margin-left: 107px !important;
    position: relative;
  }
}
.video-wrapwrap {
  position: relative;
  width: 100%;
  height: 100%;
  .video-wrapwrap-delete {
  }
}

.upload-file{
 background-color: #fbfdff !important;
 border: 1px dashed #c0ccda !important;
 border-radius: 6px !important;
}
.judge-tips{
  padding: 40px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}
</style>